import styled from "styled-components";
export const SupplierStyle = styled.div``;
